import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncPSD2AccountConfirm = loadable(
  () => import('./PSD2AccountConfirm'),
  {
    fallback: <Loader />,
  },
);
